(function () {
    function isMobileMedia() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function syncVideoPoster(video) {
      if (!video) return;

      var host = video.closest('[data-responsive-video-poster]');
      if (!host) return;

      var poster = isMobileMedia()
        ? host.dataset.mobilePoster || host.dataset.poster || ''
        : host.dataset.poster || '';

      if (poster && video.getAttribute('poster') !== poster) {
        video.setAttribute('poster', poster);
      }
    }

    function initAceiiTrainingModes() {
      var sections = document.querySelectorAll('[data-aceii-training-modes]');

      sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      var navItems = Array.prototype.slice.call(section.querySelectorAll('.mode-nav-item'));
      var videoShells = Array.prototype.slice.call(section.querySelectorAll('.mode-video-shell'));
      var videos = Array.prototype.slice.call(section.querySelectorAll('.mode-video'));
      var videoWrap = section.querySelector('.mode-video-wrap');
      var modes = navItems
        .map(function (item) {
          return item.getAttribute('data-mode');
        })
        .filter(Boolean);

      if (!modes.length) return;

      videos.forEach(syncVideoPoster);

      var currentMode = modes[0];
      var isSectionActive = false;

      function loadVideo(video, preload) {
        if (!video) return;

        var didAttachSource = false;

        syncVideoPoster(video);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = preload || 'metadata';

        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
          didAttachSource = true;
        }

        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
          if (source.dataset.src && !source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            didAttachSource = true;
          }
        });

        if (didAttachSource || video.readyState === 0) {
          video.load();
        }
      }

      function playVideo(video) {
        if (!video) return;

        loadVideo(video, 'auto');

        var promise = video.play();

        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
      }

      function pauseVideo(video, resetTime) {
        if (!video) return;

        video.pause();

        if (resetTime) {
          try {
            video.currentTime = 0;
          } catch (error) {}
        }
      }

      function pauseAllVideos() {
        videos.forEach(function (video) {
          pauseVideo(video, false);
        });
      }

      function getVideoForMode(mode) {
        var shell = videoShells.filter(function (item) {
          return item.getAttribute('data-mode') === mode;
        })[0];

        return shell ? shell.querySelector('.mode-video') : null;
      }

      function preloadNextVideo(mode) {
        var modeIndex = modes.indexOf(mode);
        var nextMode = modes[(modeIndex + 1) % modes.length];
        var nextVideo = getVideoForMode(nextMode);

        if (nextVideo && nextMode !== mode) {
          loadVideo(nextVideo, 'metadata');
        }
      }

      function setActiveVideo(mode) {
        currentMode = mode;

        videoShells.forEach(function (shell) {
          var isActive = shell.getAttribute('data-mode') === mode;
          var video = shell.querySelector('.mode-video');

          shell.classList.toggle('is-active', isActive);

          if (video) {
            video.classList.toggle('is-active', isActive);

            if (isActive && isSectionActive && !document.hidden) {
              playVideo(video);
            } else if (!isActive) {
              pauseVideo(video, true);
            }
          }
        });

        if (videoWrap) {
          videoWrap.setAttribute('data-active-mode', mode);
        }

        if (isSectionActive && !document.hidden) {
          preloadNextVideo(mode);
        }
      }

      function updateMode(mode) {
        if (!mode || mode === currentMode) return;

        navItems.forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-mode') === mode);
        });

        setActiveVideo(mode);
      }

      navItems.forEach(function (item) {
        var mode = item.getAttribute('data-mode');

        item.addEventListener('mouseenter', function () {
          updateMode(mode);
        });

        item.addEventListener('pointerenter', function () {
          updateMode(mode);
        });

        item.addEventListener('focus', function () {
          updateMode(mode);
        });

        item.addEventListener('click', function () {
          updateMode(mode);
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseAllVideos();
        } else if (isSectionActive) {
          setActiveVideo(currentMode);
        }
      });

      window.addEventListener('resize', function () {
        videos.forEach(syncVideoPoster);
      });

      setActiveVideo(currentMode);

      function activateSection() {
        isSectionActive = true;
        setActiveVideo(currentMode);
      }

      function deactivateSection() {
        isSectionActive = false;
        pauseAllVideos();
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activateSection();
            } else {
              deactivateSection();
            }
          });
        }, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0.01
        });

        observer.observe(section);
      } else {
        activateSection();
      }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAceiiTrainingModes);
    } else {
      initAceiiTrainingModes();
    }

    document.addEventListener('shopify:section:load', initAceiiTrainingModes);
  })();
